<header *ngIf="heading" (click)="getHeaderLink()" class="sub-menu-v2--header">
    <label>{{ heading }}</label>
    <i class="icon-ic-chevron-s1 icon-ic-chevron--expandable"></i>
</header>

<ul class="sub-menu-v2--dropdown">
    <li *ngFor="let item of options; let $index = index; let last = last; trackBy: trackByFn">
        <input
            legacy-css
            type="radio"
            name="{{ heading }}"
            class="sub-menu-v2-rb"
            [checked]="item?.route === currentRouteUrl"
            id="{{ heading + '-rb' + $index }}"
            (change)="radioSelection(item)" />
        <label for="{{ heading + '-rb' + $index }}"
            >{{ item.label }}
            <span *ngIf="item?.count?.toString() !== '0'" class="badge pull-right">{{ item?.count | number }}</span>
        </label>
    </li>
</ul>
